import React from 'react';
import { ResponsiveContainer, PieChart, Pie, Sector, Cell } from 'recharts';
import { Typography } from '@material-ui/core';

const scheme = ['#0F78FF', '#ccc'];

const renderPercentageText = (props) => {
  const {
    cx,
    cy,
    innerRadius,
    outerRadius,
    startAngle,
    endAngle,
    fill,
    payload,
  } = props;

  return (
    <g>
      <text font-size="35" x={cx} y={cy} dy={8} textAnchor="middle" fill={fill}>
        {parseInt(payload.val * 100)}%
      </text>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
    </g>
  );
};

const FirstYearReturn = ({ school, cx, cy, alignHeader }) => {
  const firstyearReturnData = school['latest.student.retention_rate.overall.full_time'] ? 
    [
      { isFYReturn: 'yes', val: school['latest.student.retention_rate.overall.full_time'] },
      { isFYReturn: 'no', val: 1 - school['latest.student.retention_rate.overall.full_time'] },
    ] : null;

  return (
    <>
      {firstyearReturnData && (
        <>
          <Typography align={alignHeader} variant="body2">
          Students Who Return After Their First Year
          </Typography>
          <ResponsiveContainer height={200} width={200}>
            <PieChart>
              <Pie
                data={firstyearReturnData}
                cx={cx}
                cy={cy}
                innerRadius={60}
                outerRadius={80}
                fill="#0F78FF"
                dataKey="val"
                activeIndex={0}
                activeShape={renderPercentageText}
              >
                {firstyearReturnData.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={scheme[index % scheme.length]}
                  />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>
        </>
      )}
       {!firstyearReturnData && (
         <>
         <Typography align={alignHeader} variant="subtitle1">
         Students Who Return After Their First Year
         </Typography>
          <Typography align='center' variant="caption">
          Data N/A
          </Typography>
          </>
      )}
    </>
  );
};

export default FirstYearReturn;
